import { GETTER_DEPOSIT_EDIT } from "./types";

export default {
    [GETTER_DEPOSIT_EDIT]: (state) => {
        return state.openEditDeposit;
    }
}